import { render, staticRenderFns } from "./keyAssignments.vue?vue&type=template&id=33b542a8&scoped=true&"
import script from "./keyAssignments.vue?vue&type=script&lang=js&"
export * from "./keyAssignments.vue?vue&type=script&lang=js&"
import style0 from "./keyAssignments.vue?vue&type=style&index=0&id=33b542a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b542a8",
  null
  
)

export default component.exports